import { Box, Button, Flex, Group, Select, Text } from "@mantine/core";
import React, { useEffect, useRef, useState } from "react";
import QRCode from "react-qr-code";
import { useReactToPrint } from "react-to-print"; // Thêm thư viện này
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import { IconPrinter } from "@tabler/icons-react";

interface ExtendedSelectListItem extends SelectListItemBase {
  attr8: string;
  attr6: string;
}

export const QrCodeWarranty = () => {
  const [dataBranch, setDataBranch] = useState<ExtendedSelectListItem[]>([]);
  const [selectedBranch, setSelectedBranch] = useState<string | null>(null);
  const URL = process.env.REACT_APP_CLIENT_URL ?? "";

  const qrRef = useRef<HTMLDivElement>(null);
  const componentRef = React.useRef(null);
  const printStarted = useRef(false);

  const a = dataBranch.find((item) => item.value === selectedBranch);

  const InfoPrint = {
    NameBranch: a?.text,
    Phone: a?.attr8,
    Address: a?.att1,
    text: a?.text,
    attr6: a?.attr6,
  };
  const warrantyInfo = selectedBranch
    ? `${URL}send/warranty-claim/${selectedBranch}`
    : "";

  const handlePrint = useReactToPrint({
    contentRef: componentRef,

    onBeforePrint: async () => {
      printStarted.current = true; // Đánh dấu bắt đầu in
    },
    pageStyle: `
           @page{
             size: A5;
              margin: 7mm 0 7mm 0;
           }
           body:{
             margin: 0;
             color: #000;
           }`,
    // onBeforePrint: () => console.log("Before printing..."),
    // onAfterPrint: () => console.log("After printing..."),
  });

  const fetchDataBranch = async () => {
    const response = await repositoryPos.get<
      MessageResponse<ExtendedSelectListItem[]>
    >("/api/v1/TblDmInventory/get-select-branch?auth=false");

    if (response && response.success) {
      setDataBranch(response.data);
    }
  };

  useEffect(() => {
    fetchDataBranch();
  }, []);

  // Dùng react-to-print

  return (
    <Box>
      <Group justify="space-between" align="center">
        <BreadcrumbLayout1 />
        {selectedBranch && (
          <Button
            leftSection={<IconPrinter size={16} />}
            variant="filled"
            color="#228be6"
            style={{
              marginRight: "10px",
            }}
            onClick={() => {
              handlePrint();
            }}
          >
            In
          </Button>
        )}
      </Group>
      <div
        style={{
          width: "100%",
          height: "70vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Flex
          gap={10}
          direction="column"
          align="center"
          justify="space-between"
          mt={20}
        >
          {/* QR Code */}
          <div ref={qrRef}>
            {selectedBranch && (
              <div style={{ textAlign: "center" }}>
                <QRCode value={warrantyInfo} size={256} />
              </div>
            )}
          </div>

          <Text tt="uppercase" fw={600} size="xl" ta="center">
            Quét mã QR để hiển thị giao diện biểu mẫu gửi yêu cầu bảo hành sản
            phẩm.
          </Text>
          <Text size="sm" ta="center">
            Vui lòng chọn chi nhánh để hiển thị QR Code
          </Text>
          <Select
            searchable
            flex={1}
            clearable
            fw={600}
            width={350}
            data={dataBranch
              ?.map((ele) => ({
                label: ele.text,
                value: ele.value,
              }))
              .slice(1)}
            placeholder="Vui lòng chọn chi nhánh"
            value={selectedBranch}
            onChange={(selectedDescription) => {
              setSelectedBranch(selectedDescription);
            }}
          />
        </Flex>
      </div>
      <Box style={{ display: "none" }}>
        <div ref={componentRef}>
          <div
            style={{
              width: "100vw",
              height: "80vh", // full viewport height
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              padding: 20,
            }}
          >
            <Flex gap={5}>
              <Text fw={500}>HACOM:</Text>
              <Text fw={500}>{InfoPrint.text ?? ""}</Text>
            </Flex>
            <Flex gap={5}>
              <Text fw={500}>Địa chỉ:</Text>
              <Text fw={500}>{InfoPrint.Address ?? ""}</Text>
            </Flex>
            <Flex gap={5}>
              <Text fw={500}>Số điện thoại:</Text>
              <Text fw={500}>{InfoPrint.Phone ?? ""}</Text>
            </Flex>
            <Box mt={30}>
              <QRCode value={warrantyInfo} size={300} />
            </Box>
            <Text tt="uppercase" fw={600} size="lg" mt={20}>
              Quét QR để tiếp nhận yêu cầu bảo hành sản phẩm
            </Text>
          </div>
        </div>
      </Box>
    </Box>
  );
};
